module.exports = __webpack_public_path__ + "static/media/step1.dc4c30e7.svg";